import { createAction } from 'redux-actions'

import { SessionNamingConventionType } from '@tabeeb/enums'
import { ContentNamePartRequest } from '@tabeeb/contracts/main-api/swagger-main-api'

export const openTenantFormsDialog = createAction<{ sncType: SessionNamingConventionType; subdomain?: string }>(
  'OPEN_TENANT_FORMS_DIALOG'
)
export const closeTenantFormsDialog = createAction('CLOSE_TENANT_FORMS_DIALOG')

export const submitTenantFormAnswers = createAction<{
  description: string
  contentNameParts: ContentNamePartRequest[]
}>('SUBMIT_TENANT_FORM_ANSWERS')
